<!-- src/components/U1075u1083u1072u1074u1085u1072u1103.vue -->
<!-- Главная страница студента -->

<template>
	<div class="student-dashboard screen">
		<div class="dashboard-content">
			<div class="view-581"></div>

			<!-- ХЕДЕР -->
			<StudentHeader
				:house-class-name="houseFillSvgrepoCom1Props?.className"
				:menu-labels="{
					settings: text962,
					help: text961,
					profile: text960,
					logout: text958,
				}"
				@search="handleSearch"
				@logout="handleLogout"
				@profile-click="onProfileClick"
			/>

			<!-- МОИ КУРСЫ -->
			<div class="my-courses-position" ref="myCoursesBlock">
				<StudentMyCourses
					:courses="enrolledCourses"
					:loading="loadingEnrolled"
					@go-to-course="goToEnrolledCourse"
					@more-click="onMoreCoursesClick"
				/>
			</div>

			<h1 class="main-title poppins-semi-bold-ebony-clay-36px">
				{{ welcomeMessage }}
			</h1>

			<!-- БЛОКИ С КОНТЕНТОМ - ДИНАМИЧЕСКАЯ ВЕРСТКА -->
			<div class="content-blocks">
				<!-- Секция конференций (слайдер карточек) - занимает всю ширину -->
				<div class="conferences-wrapper">
					<StudentConf
						:conferences="studentConferences"
						:loading="loadingConferences"
						:error="conferencesError"
						:include-past="includePastConferences"
						@join-conference="joinConference"
						@toggle-past="onTogglePast"
						@retry="loadStudentConferences"
					/>
				</div>

				<!-- Строка: Модули + Календарь -->
				<div class="modules-calendar-row">
					<div class="modules-homework-column">
						<!-- Доступные модули с пагинацией -->
						<div class="modules-wrapper" id="modules">
							<div class="paginated-section">
								<StudentModules
									:modules="paginatedModules"
									:loading="loadingModules"
									@course-filter-change="onModulesCourseFilter"
								/>

								<!-- Навигация по модулям -->
								<div
									v-if="allModules.length > modulesPerPage"
									class="pagination-controls"
								>
									<button
										class="pagination-btn pagination-btn--prev"
										:disabled="modulesPage <= 1"
										@click="prevModulesPage"
										aria-label="Предыдущая страница модулей"
									>
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
											<path
												d="M15 18L9 12L15 6"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</button>

									<span class="pagination-info">
										{{ modulesPage }} / {{ modulesTotalPages }}
									</span>

									<button
										class="pagination-btn pagination-btn--next"
										:disabled="modulesPage >= modulesTotalPages"
										@click="nextModulesPage"
										aria-label="Следующая страница модулей"
									>
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
											<path
												d="M9 18L15 12L9 6"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>

						<!-- Домашние задания с пагинацией -->
						<div class="homework-wrapper">
							<div class="paginated-section">
								<StudentHomework
									:homework="paginatedHomework"
									:loading="loadingHomework"
									@course-filter-change="onHomeworkCourseFilter"
								/>

								<!-- Навигация по домашкам -->
								<div
									v-if="allHomework.length > homeworkPerPage"
									class="pagination-controls"
								>
									<button
										class="pagination-btn pagination-btn--prev"
										:disabled="homeworkPage <= 1"
										@click="prevHomeworkPage"
										aria-label="Предыдущая страница домашних заданий"
									>
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
											<path
												d="M15 18L9 12L15 6"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</button>

									<span class="pagination-info">
										{{ homeworkPage }} / {{ homeworkTotalPages }}
									</span>

									<button
										class="pagination-btn pagination-btn--next"
										:disabled="homeworkPage >= homeworkTotalPages"
										@click="nextHomeworkPage"
										aria-label="Следующая страница домашних заданий"
									>
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
											<path
												d="M9 18L15 12L9 6"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
					</div>

					<!-- Календарь конференций -->
					<div class="calendar-wrapper">
						<View58
							:conferences="conferencesWithColors"
							:loading="loadingConferences"
							@join-conference="joinConference"
						/>
					</div>
				</div>
			</div>

			<!-- РЕКОМЕНДУЕМЫЕ КУРСЫ -->
			<div class="recommended-courses-wrapper" id="my_recommended-courses">
				<StudentCoursesSlider
					:title="text854"
					:courses="recommendedCourses"
					:loading="loading"
					:search-query="searchQuery"
					:current-page="currentPage"
					:total-pages="totalPages"
					@go-to-course="goToCourse"
					@prev-page="prevPage"
					@next-page="nextPage"
					@go-to-page="goToPage"
				>
					<template #header-actions>
						<div class="recommended-filter-bar">
							<select
								id="recommended-teacher"
								class="recommended-filter-select"
								v-model="selectedTeacherKey"
							>
								<option value="">Все преподаватели</option>
								<option
									v-for="teacher in teacherOptions"
									:key="teacher.key"
									:value="teacher.key"
								>
									{{ teacher.label }}
								</option>
							</select>
						</div>
					</template>
				</StudentCoursesSlider>
			</div>
		</div>

		<StudentCourseChoiceModal
			:is-open="showCourseSelectionModal && !showOnboardingTour"
			:user-first-name="currentUserFirstName"
			:courses="recommendedCoursesBase"
			@dismiss="handleCourseChoiceDismiss"
			@go-to-course="goToCourse"
			@go-to-catalog="goToCatalogFromModal"
		/>

		<OnboardingTour
			v-if="showOnboardingTour"
			:steps="onboardingSteps"
			:auto-start="true"
			@skip="handleOnboardingFinish"
			@complete="handleOnboardingFinish"
		/>

		<button
			type="button"
			class="student-onboarding-restart"
			aria-label="Повторить обучение"
			@click="restartOnboardingTour"
		>
			<span class="student-onboarding-restart__icon" aria-hidden="true">
				<svg width="22" height="22" viewBox="0 0 24 24" fill="none">
					<path
						d="M9 18H15M10 21H14M8.5 14.5C7.55 13.72 6.84 12.68 6.44 11.5C6.04 10.32 5.97 9.06 6.24 7.84C6.51 6.62 7.12 5.5 8 4.61C8.88 3.72 10 3.09 11.22 2.81C12.44 2.53 13.7 2.58 14.88 2.97C16.07 3.36 17.12 4.06 17.9 5C18.68 5.95 19.17 7.1 19.31 8.31C19.45 9.52 19.24 10.75 18.71 11.85C18.18 12.95 17.35 13.87 16.32 14.5C15.97 14.72 15.67 15 15.44 15.34C15.22 15.68 15.08 16.06 15.03 16.46V17H8.97V16.46C8.92 16.06 8.78 15.68 8.56 15.34C8.33 15 8.03 14.72 7.68 14.5H8.5Z"
						stroke="currentColor"
						stroke-width="1.7"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</span>
			<span class="student-onboarding-restart__label">Повторить обучение</span>
		</button>

		<!-- FOOTER -->
		<ViewSubsection />
	</div>
</template>

<script>
// Компоненты
import StudentHeader from '@/components/student/StudentHeader.vue'
import StudentMyCourses from '@/components/student/StudentMyCourses.vue'
import StudentCoursesSlider from '@/components/student/StudentCoursesSlider.vue'
import StudentConf from '@/components/student/StudentConf.vue'
import StudentModules from '@/components/student/StudentModules.vue'
import StudentHomework from '@/components/student/StudentHomework.vue'
import StudentCourseChoiceModal from '@/components/student/StudentCourseChoiceModal.vue'
import OnboardingTour from '@/components/onboarding/OnboardingTour.vue'
import onboardingMyCoursesHint from '@/assets/cdn-animaapp/hints/Screenshot_moi_curs.png'
import onboardingNotificationsHint from '@/assets/cdn-animaapp/hints/Screenshot_notifi.png'
import onboardingSearchHint from '@/assets/cdn-animaapp/hints/Screenshot_seach.png'
import onboardingProfileHint from '@/assets/cdn-animaapp/hints/Screenshot_profil.png'
import onboardingConferencesHint from '@/assets/cdn-animaapp/hints/Screenshot_conf.png'
import onboardingCalendarHint from '@/assets/cdn-animaapp/hints/Screenshot_calendar.png'
import onboardingModulesHint from '@/assets/cdn-animaapp/hints/Screenshot_module.png'
import onboardingHomeworkHint from '@/assets/cdn-animaapp/hints/Screenshot_dz.png'
import onboardingRecommendedHint from '@/assets/cdn-animaapp/hints/Screenshot_rec.png'
import View57 from './View57.vue'
import View58 from './View58.vue'
import ViewSubsection from '@/views/teacher/TeacherDashboard/DivWrapperScreen/sections/ViewSubsection.vue'

// Сервисы
import { modulesService } from '@/services/modules'
import { lessonsService } from '@/services/lessons'
import { testsService } from '@/services/tests'
import { homeworkService } from '@/services/homework'
import { practicalService } from '@/services/practical'
import { formatDateTime as formatDateTimeValue } from '@/utils/dateTime'

// Composables
import { useCourses, useEnrolledCourses } from '@/composables/useCourses'
import { useStudentConferences } from '@/composables/useConferences'

import { computed } from 'vue'
import { useAppStore } from '@/stores/useAppStore'

/**
 * Утилита для задержки между запросами
 */
const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

/**
 * Выполнение запросов с ограничением параллельности
 * @param {Array} items - массив элементов
 * @param {Function} fn - функция для выполнения
 * @param {number} concurrency - максимум параллельных запросов
 * @param {number} delayMs - задержка между batch'ами
 */
async function batchRequests(items, fn, concurrency = 2, delayMs = 300) {
	const results = []

	for (let i = 0; i < items.length; i += concurrency) {
		const batch = items.slice(i, i + concurrency)
		const batchResults = await Promise.all(
			batch.map(item =>
				fn(item).catch(err => {
					console.warn(`Ошибка запроса:`, err.message)
					return null
				})
			)
		)
		results.push(...batchResults)

		// Задержка между batch'ами (кроме последнего)
		if (i + concurrency < items.length) {
			await delay(delayMs)
		}
	}

	return results
}

export default {
	name: 'StudentDashboard',

	components: {
		StudentHeader,
		StudentMyCourses,
		StudentCoursesSlider,
		StudentConf,
		StudentModules,
		StudentHomework,
		StudentCourseChoiceModal,
		OnboardingTour,
		View57,
		View58,
		ViewSubsection,
	},

	props: [
		'text854',
		'text951',
		'text956',
		'text958',
		'text960',
		'text961',
		'text962',
		'view57Props',
		'houseFillSvgrepoCom1Props',
	],

	data() {
		return {
			// Модули - реальные данные
			allModules: [],
			loadingModules: false,
			modulesPage: 1,
			modulesPerPage: 5,

			// Домашние задания - реальные данные
			allHomework: [],
			loadingHomework: false,
			homeworkPage: 1,
			homeworkPerPage: 5,

			conferencesError: '',

			// Флаг для предотвращения повторной загрузки
			dataLoaded: false,

			selectedTeacherKey: '',
			showCourseSelectionModal: false,
			courseChoiceModalDismissed: false,
			showOnboardingTour: false,
			onboardingSavedInSession: false,
			myCoursesObserver: null,
			myCoursesMedia: null,
			updateMyCoursesOffset: null,
			moduleCountsInFlight: false,
			moduleCountsBackoffUntil: 0,
		}
	},

	computed: {
		/**
		 * Модули, сгруппированные по курсам
		 */
		groupedModules() {
			const groups = {}

			this.allModules.forEach(module => {
				const courseName = module.courseName || 'Неизвестный курс'

				if (!groups[courseName]) {
					groups[courseName] = {
						courseName,
						items: [],
					}
				}

				groups[courseName].items.push(module)
			})

			return Object.values(groups).sort((a, b) =>
				a.courseName.localeCompare(b.courseName)
			)
		},

		/**
		 * ДЗ, сгруппированные по курсам
		 */
		groupedHomework() {
			const groups = {}

			this.allHomework.forEach(hw => {
				const courseName = hw.courseName || 'Неизвестный курс'

				if (!groups[courseName]) {
					groups[courseName] = {
						courseName,
						items: [],
					}
				}

				groups[courseName].items.push(hw)
			})

			return Object.values(groups).sort((a, b) =>
				a.courseName.localeCompare(b.courseName)
			)
		},

		/**
		 * Общее количество страниц модулей
		 */
		modulesTotalPages() {
			return Math.max(
				1,
				Math.ceil(this.allModules.length / this.modulesPerPage)
			)
		},

		/**
		 * Общее количество страниц домашек
		 */
		homeworkTotalPages() {
			return Math.max(
				1,
				Math.ceil(this.allHomework.length / this.homeworkPerPage)
			)
		},

		/**
		 * Модули для текущей страницы (С ГРУППИРОВКОЙ + ПАГИНАЦИЕЙ)
		 */
		paginatedModules() {
			// 1. Берем срез из плоского списка всех модулей
			const start = (this.modulesPage - 1) * this.modulesPerPage
			const end = start + this.modulesPerPage
			const slicedModules = this.allModules.slice(start, end)

			// 2. Группируем только эти модули
			const groups = {}
			slicedModules.forEach(module => {
				const courseName = module.courseName || 'Неизвестный курс'

				if (!groups[courseName]) {
					groups[courseName] = {
						courseName,
						items: [],
					}
				}

				groups[courseName].items.push(module)
			})

			// 3. Преобразуем в массив и сортируем
			return Object.values(groups)
				.filter(group => group && group.items && group.items.length > 0)
				.sort((a, b) => a.courseName.localeCompare(b.courseName))
		},

		/**
		 * ДЗ для текущей страницы (С ГРУППИРОВКОЙ + ПАГИНАЦИЕЙ)
		 */
		paginatedHomework() {
			// 1. Берем срез из плоского списка всех ДЗ
			const start = (this.homeworkPage - 1) * this.homeworkPerPage
			const end = start + this.homeworkPerPage
			const slicedHomework = this.allHomework.slice(start, end)

			// 2. Группируем только эти ДЗ
			const groups = {}
			slicedHomework.forEach(hw => {
				const courseName = hw.courseName || 'Неизвестный курс'

				if (!groups[courseName]) {
					groups[courseName] = {
						courseName,
						items: [],
					}
				}

				groups[courseName].items.push(hw)
			})

			// 3. Преобразуем в массив и сортируем
			return Object.values(groups)
				.filter(group => group && group.items && group.items.length > 0)
				.sort((a, b) => a.courseName.localeCompare(b.courseName))
		},

		recommendedCoursesBase() {
			const enrolledIds = new Set(
				(this.enrolledCourseIds || [])
					.map(id => (typeof id === 'string' ? parseInt(id, 10) : id))
					.filter(id => Number.isFinite(id))
			)

			return (this.filteredCourses || []).filter(course => {
				const rawId =
					course?.id ?? course?.course_id ?? course?.courseId ?? null
				const normalizedId =
					typeof rawId === 'string' ? parseInt(rawId, 10) : rawId

				if (!Number.isFinite(normalizedId)) return true
				return !enrolledIds.has(normalizedId)
			})
		},

		teacherOptions() {
			const seen = new Map()

			this.recommendedCoursesBase.forEach(course => {
				const email = course?.teacher_email || ''
				const name = course?.teacher_name || ''
				const key = email || name
				const label = name && email ? `${name} (${email})` : name || email

				if (!key || seen.has(key)) return
				seen.set(key, { key, label })
			})

			return Array.from(seen.values()).sort((a, b) =>
				a.label.localeCompare(b.label)
			)
		},

		recommendedCourses() {
			if (!this.selectedTeacherKey) return this.recommendedCoursesBase
			return this.recommendedCoursesBase.filter(course => {
				const email = course?.teacher_email || ''
				const name = course?.teacher_name || ''
				return email === this.selectedTeacherKey || name === this.selectedTeacherKey
			})
		},

		onboardingSteps() {
			return [
				{
					target: '.sh-notifications',
					fallbackTargets: ['.sh-nav'],
					position: 'bottom',
					title: '1. Уведомления',
					text: 'Получайте уведомление о важных событиях',
					hintImage: onboardingNotificationsHint,
					spotlightPadding: 6,
				},
				{
					target: '.sh-search-field',
					fallbackTargets: ['.sh-search'],
					position: 'bottom',
					title: '2. Поиск',
					text: 'В поиске вы можете быстро найти нужный курс по названию.',
					hintImage: onboardingSearchHint,
					spotlightPadding: 6,
				},
				{
					target: '.sh-profile',
					fallbackTargets: ['.sh-profile-btn'],
					position: 'bottom',
					title: '3. Профиль',
					text: 'Здесь вы можете перейти в свой профиль, где доступна личная информация, оценки, сертификаты и статистика обучения. В разделе «Настройки» можно включить двухфакторную аутентификацию (2FA), изменить пароль и настроить уведомления.',
					hintImage: onboardingProfileHint,
					spotlightPadding: 6,
				},
				{
					target: '.my-courses-position',
					fallbackTargets: ['.my-courses-section'],
					position: 'bottom',
					title: '4. Мои курсы',
					text: 'В этом блоке будут отображаться все ваши курсы: в процессе, на паузе и завершённые. Здесь вы также можете отслеживать прогресс прохождения каждого курса и видеть текущий статус обучения.',
					hintImage: onboardingMyCoursesHint,
					spotlightPadding: 10,
				},
				{
					target: '.conferences-section',
					fallbackTargets: ['.conferences-wrapper', '.content-blocks'],
					position: 'left',
					title: '5. Конференции',
					text: 'Здесь будут отображаться ваши встречи с преподавателем и ближайшие конференции курсов, на которые вы записаны.',
					hintImage: onboardingConferencesHint,
					spotlightPadding: 18,
					hintImageMaxWidth: 820,
					hintImageMaxHeight: 700,
					tooltipWidth: 900,
					tooltipHeight: 1120,
					tooltipRight: 24,
				},
				{
					target: '.calendar-panel',
					fallbackTargets: ['.calendar-wrapper'],
					position: 'left',
					title: '6. Календарь',
					text: 'В данном разделе представлен календарь, в котором будут указаны даты конференций.',
					hintImage: onboardingCalendarHint,
					spotlightPadding: 10,
					hintImageMaxWidth: 760,
					hintImageMaxHeight: 620,
					tooltipWidth: 860,
					tooltipHeight: 1080,
				},
				{
					target: '.modules-wrapper',
					fallbackTargets: ['#modules'],
					position: 'right',
					title: '7. Модули',
					text: 'В данном разделе будут представлены все доступные учебные модули. Доступ к ним будет предоставляться последовательно в соответствии с программой обучения. Модули можно сортировать по курсам',
					hintImage: onboardingModulesHint,
					spotlightPadding: 10,
					hintImageMaxWidth: 760,
					hintImageMaxHeight: 620,
					tooltipWidth: 860,
					tooltipHeight: 1080,
				},
				{
					target: '.homework-wrapper',
					fallbackTargets: ['.modules-homework-column'],
					position: 'right',
					title: '8. Домашние задания',
					text: 'В данном разделе будут представлены ваши домашние задания и установленные сроки их выполнения.',
					hintImage: onboardingHomeworkHint,
					spotlightPadding: 10,
					hintImageMaxWidth: 760,
					hintImageMaxHeight: 620,
					tooltipWidth: 860,
					tooltipHeight: 1080,
				},
				{
					target: '.recommended-courses-wrapper .slider-wrapper',
					fallbackTargets: [
						'.recommended-courses-wrapper .slider-section',
						'.recommended-courses-wrapper',
						'#my_recommended-courses',
					],
					position: 'top',
					scrollBlock: 'start',
					title: '9. Рекомендации',
					text: 'Если вы ещё не записаны на курс, в этом разделе вы сможете выбрать курс, ознакомиться с программой и преподавателем, а также записаться.',
					hintImage: onboardingRecommendedHint,
					spotlightPadding: 12,
					hintImageMaxWidth: 820,
					hintImageMaxHeight: 700,
					tooltipWidth: 900,
					tooltipHeight: 1120,
				},
			]
		},

	},

	setup() {
		const appStore = useAppStore()
		const currentUser = computed(() => appStore.currentUser || null)
		const hasSeenOnboarding = computed(() => {
			const user = currentUser.value
			if (!user) return true
			if (typeof user.hasSeenOnboarding === 'boolean')
				return user.hasSeenOnboarding
			if (typeof user.has_seen_onboarding === 'boolean')
				return user.has_seen_onboarding
			if (typeof user.isFirstLogin === 'boolean') return !user.isFirstLogin
			if (typeof user.is_first_login === 'boolean') return !user.is_first_login
			if (typeof window !== 'undefined') {
				const fromStorage = localStorage.getItem('is_first_login')
				if (fromStorage === 'true') return false
				if (fromStorage === 'false') return true
			}
			return true
		})

		const currentUserFirstName = computed(() => {
			const user = currentUser.value
			if (!user) return 'друг'
			const fullName = user.fullName || user.full_name || ''
			const parts = fullName.trim().split(/\s+/).filter(Boolean)
			return parts.length >= 2 ? parts[1] : parts[0] || 'друг'
		})

		// Приветственное сообщение с именем пользователя из store
		const welcomeMessage = computed(() => {
			return `Добро пожаловать, ${currentUserFirstName.value}! Готовы продолжить обучение?`
		})

		const {
			loading,
			searchQuery,
			currentPage,
			totalPages,
			filteredCourses,
			loadCourses,
			search,
			goToPage,
			prevPage,
			nextPage,
		} = useCourses()

		const {
			enrolledCourses,
			loading: loadingEnrolled,
			enrolledCourseIds,
			loadEnrolledCourses,
		} = useEnrolledCourses()

		const {
			conferences: studentConferences,
			loading: loadingConferences,
			includePast: includePastConferences,
			conferencesWithColors,
			loadConferences: loadStudentConferencesBase,
			togglePast,
			joinConference: joinConferenceAction,
		} = useStudentConferences(enrolledCourseIds)

		return {
			currentUser,
			hasSeenOnboarding,
			welcomeMessage,
			currentUserFirstName,
			loading,
			searchQuery,
			currentPage,
			totalPages,
			filteredCourses,
			loadCourses,
			search,
			goToPage,
			prevPage,
			nextPage,
			enrolledCourses,
			loadingEnrolled,
			enrolledCourseIds,
			loadEnrolledCourses,
			studentConferences,
			loadingConferences,
			includePastConferences,
			conferencesWithColors,
			loadStudentConferencesBase,
			togglePast,
			joinConferenceAction,
		}
	},

	watch: {
		'$route.hash'(newHash) {
			if (!newHash) return
			this.scrollToCurrentHashSoon({ behavior: 'auto' })
		},
	},

	mounted() {
		if (this.dataLoaded) return
		this.dataLoaded = true

		this.initMyCoursesOffsetObserver()
		this.scrollToCurrentHashSoon({ behavior: 'auto' })
		this.loadAllDataSequentially().catch(error => {
			console.error('Ошибка загрузки данных дашборда:', error)
		})
	},

	beforeUnmount() {
		this.destroyMyCoursesOffsetObserver()
	},

	methods: {
		scrollToCurrentHashSoon({ behavior = 'auto', attempts = 24 } = {}) {
			const hash = this.$route?.hash
			if (!hash) return

			let triesLeft = attempts
			const tryScroll = () => {
				const target = document.querySelector(hash)
				if (target) {
					this.scrollToCurrentHash({ behavior })
					return
				}

				triesLeft -= 1
				if (triesLeft > 0) {
					window.requestAnimationFrame(tryScroll)
				}
			}

			window.requestAnimationFrame(tryScroll)
		},

		scrollToCurrentHash({ behavior = 'smooth' } = {}) {
			const hash = this.$route?.hash
			if (!hash) return

			const target = document.querySelector(hash)
			if (!target) return

			const offset = 24
			const targetTop =
				window.pageYOffset + target.getBoundingClientRect().top - offset
			const scrollTop = Math.max(0, Math.round(targetTop))

			window.scrollTo({
				top: scrollTop,
				behavior,
			})
		},

		initMyCoursesOffsetObserver() {
			if (typeof window === 'undefined') return
			const media = window.matchMedia('(max-width: 1800px)')
			this.myCoursesMedia = media

			const handleChange = event => {
				if (event.matches) {
					this.startMyCoursesObserver()
				} else {
					this.stopMyCoursesObserver()
				}
			}

			if (media.matches) {
				this.startMyCoursesObserver()
			}

			if (media.addEventListener) {
				media.addEventListener('change', handleChange)
			} else if (media.addListener) {
				media.addListener(handleChange)
			}

			this._myCoursesMediaHandler = handleChange
		},

		startMyCoursesObserver() {
			const block = this.$refs.myCoursesBlock
			const container = this.$el?.querySelector?.('.dashboard-content')
			if (!block || !container || typeof ResizeObserver === 'undefined') return

			const updateOffset = () => {
				const offset = Math.max(0, block.offsetTop + block.offsetHeight)
				container.style.setProperty(
					'--my-courses-offset',
					`${Math.ceil(offset)}px`
				)
			}

			this.updateMyCoursesOffset = updateOffset
			updateOffset()

			if (!this.myCoursesObserver) {
				this.myCoursesObserver = new ResizeObserver(updateOffset)
				this.myCoursesObserver.observe(block)
				window.addEventListener('resize', updateOffset)
			}
		},

		stopMyCoursesObserver() {
			const container = this.$el?.querySelector?.('.dashboard-content')
			if (this.myCoursesObserver) {
				this.myCoursesObserver.disconnect()
				this.myCoursesObserver = null
			}
			if (this.updateMyCoursesOffset) {
				window.removeEventListener('resize', this.updateMyCoursesOffset)
				this.updateMyCoursesOffset = null
			}
			if (container) {
				container.style.setProperty('--my-courses-offset', '0px')
			}
		},

		destroyMyCoursesOffsetObserver() {
			this.stopMyCoursesObserver()
			if (this.myCoursesMedia) {
				const handler = this._myCoursesMediaHandler
				if (this.myCoursesMedia.removeEventListener) {
					this.myCoursesMedia.removeEventListener('change', handler)
				} else if (this.myCoursesMedia.removeListener) {
					this.myCoursesMedia.removeListener(handler)
				}
				this.myCoursesMedia = null
				this._myCoursesMediaHandler = null
			}
		},
		/**
		 * Обработка смены фильтра курса для модулей
		 */
		onModulesCourseFilter(courseName) {
			console.log('Фильтр модулей по курсу:', courseName || 'Все курсы')
			// Можно сбросить страницу пагинации при смене фильтра
			this.modulesPage = 1
		},

		/**
		 * Обработка смены фильтра курса для ДЗ
		 */
		onHomeworkCourseFilter(courseName) {
			console.log('Фильтр ДЗ по курсу:', courseName || 'Все курсы')
			// Можно сбросить страницу пагинации при смене фильтра
			this.homeworkPage = 1
		},

		normalizeBoolean(value) {
			if (value === null || value === undefined) return null
			if (typeof value === 'boolean') return value
			if (typeof value === 'number') return value !== 0
			if (typeof value === 'string') {
				const normalized = value.trim().toLowerCase()
				if (['true', '1', 'yes', 'y', 'да'].includes(normalized)) return true
				if (['false', '0', 'no', 'n', 'нет'].includes(normalized))
					return false
			}
			return Boolean(value)
		},

		isRateLimitError(error) {
			const status = Number(error?.status ?? error?.response?.status ?? 0)
			return status === 429
		},

		getRetryAfterMs(error, fallbackMs = 120000) {
			const retryAfterHeader =
				error?.response?.headers?.['retry-after'] ||
				error?.response?.headers?.RetryAfter ||
				null
			if (!retryAfterHeader) return fallbackMs
			const retryAfterSeconds = Number(retryAfterHeader)
			if (Number.isFinite(retryAfterSeconds)) {
				return Math.max(1000, retryAfterSeconds * 1000)
			}
			const retryAfterDate = Date.parse(retryAfterHeader)
			if (!Number.isNaN(retryAfterDate)) {
				return Math.max(1000, retryAfterDate - Date.now())
			}
			return fallbackMs
		},

		isPausedStatus(value) {
			if (!value && value !== 0) return false
			const normalized = String(value).trim().toLowerCase()
			return [
				'paused',
				'on_hold',
				'on-hold',
				'hold',
				'stopped',
				'suspended',
			].includes(normalized)
		},

		isEnrollmentPaused(enrollment) {
			if (!enrollment) return false
			const rawStatus =
				enrollment.enrollment_status ??
				enrollment.enrollmentStatus ??
				enrollment.status ??
				enrollment.state ??
				enrollment.course_status ??
				enrollment.courseStatus ??
				null
			return this.isPausedStatus(rawStatus)
		},

		isModuleCompleted(module) {
			if (!module) return false
			if (module?.is_completed !== undefined)
				return this.normalizeBoolean(module.is_completed) === true
			if (module?.isCompleted !== undefined)
				return this.normalizeBoolean(module.isCompleted) === true
			if (module?.completed !== undefined)
				return this.normalizeBoolean(module.completed) === true
			const rawStatus = String(module?.status || '').toLowerCase()
			if (['completed', 'passed', 'done', 'finished'].includes(rawStatus)) {
				return true
			}
			const percent =
				module?.completion_percent ??
				module?.completionPercent ??
				module?.progress_percent ??
				module?.progressPercent ??
				module?.progress ??
				null
			if (typeof percent === 'number') return percent >= 100
			if (typeof percent === 'string' && percent.trim() !== '') {
				const parsed = Number(percent)
				if (!Number.isNaN(parsed)) return parsed >= 100
			}
			return false
		},

		applyModuleProgressLocks(modules) {
			if (!Array.isArray(modules)) return []
			let currentCourse = null
			let hasCurrent = false
			return modules.map(module => {
				const courseId = module.courseId ?? module.course_id ?? null
				if (courseId !== currentCourse) {
					currentCourse = courseId
					hasCurrent = false
				}
				if (module.isCompleted) {
					return { ...module, status: 'completed' }
				}
				if (module.isPaused) {
					return { ...module, status: 'locked' }
				}
				if (!hasCurrent && !module.isHidden && !module.isExplicitlyLocked) {
					hasCurrent = true
					return { ...module, status: 'available' }
				}
				if (!hasCurrent && module.isExplicitlyLocked) {
					hasCurrent = true
					return { ...module, status: 'locked' }
				}
				return { ...module, status: 'locked' }
			})
		},

		getHomeworkSubmissionStatus(item) {
			return (
				item?.submissionStatus ??
				item?.submission_status ??
				item?.submission_state ??
				item?.submissionState ??
				null
			)
		},

		getHomeworkOrder(item) {
			return (
				item?.order ??
				item?.order_number ??
				item?.position ??
				item?.sort_order ??
				item?.sortOrder ??
				item?.index ??
				null
			)
		},

		isHomeworkCompleted(item) {
			if (!item) return false
			if (item?.is_completed !== undefined)
				return this.normalizeBoolean(item.is_completed) === true
			if (item?.isCompleted !== undefined)
				return this.normalizeBoolean(item.isCompleted) === true
			if (item?.completed !== undefined)
				return this.normalizeBoolean(item.completed) === true
			const status = this.getHomeworkSubmissionStatus(item)
			if (status) return ['completed', 'graded', 'reviewed'].includes(status)
			if (item?.completion_percent !== undefined) {
				return Number(item.completion_percent) >= 100
			}
			if (item?.completionPercent !== undefined) {
				return Number(item.completionPercent) >= 100
			}
			return false
		},

		isHomeworkSubmitted(item) {
			if (!item) return false
			if (item?.is_submitted !== undefined || item?.is_completed !== undefined) {
				return (
					this.normalizeBoolean(item.is_submitted) === true ||
					this.normalizeBoolean(item.is_completed) === true
				)
			}
			if (item?.isSubmitted !== undefined)
				return this.normalizeBoolean(item.isSubmitted) === true
			if (item?.submitted !== undefined)
				return this.normalizeBoolean(item.submitted) === true
			const status = this.getHomeworkSubmissionStatus(item)
			if (status)
				return [
					'submitted',
					'completed',
					'graded',
					'reviewed',
					'needs_revision',
				].includes(status)
			return this.isHomeworkCompleted(item)
		},

		getHomeworkDueAt(item) {
			if (!item) return null
			const dateValue =
				item?.dueDateValue ?? item?.dueDate ?? item?.deadline ?? null
			if (!dateValue) return null
			const date = new Date(dateValue)
			if (Number.isNaN(date.getTime())) return null
			const timeValue = item?.dueTimeValue ?? item?.dueTime ?? null
			if (!timeValue) return date
			const [hours, minutes, seconds] = String(timeValue)
				.trim()
				.split(':')
				.map(part => Number(part))
			if (!Number.isNaN(hours)) date.setHours(hours)
			if (!Number.isNaN(minutes)) date.setMinutes(minutes)
			if (!Number.isNaN(seconds)) date.setSeconds(seconds)
			date.setMilliseconds(0)
			return date
		},

		isHomeworkLate(item) {
			if (!item) return false
			if (this.isHomeworkCompleted(item) || this.isHomeworkSubmitted(item))
				return false
			const dueAt = this.getHomeworkDueAt(item)
			if (!dueAt) return false
			return Date.now() > dueAt.getTime()
		},

		applyHomeworkProgressLocks(homework, moduleStatusMap) {
			if (!Array.isArray(homework)) return []
			const statusMap =
				moduleStatusMap ||
				new Map(
					this.allModules.map(module => [
						module.id,
						module.status || 'available',
					]),
				)
			const grouped = new Map()
			homework.forEach(item => {
				const moduleId = item?.moduleId ?? item?.module_id ?? null
				if (!grouped.has(moduleId)) grouped.set(moduleId, [])
				grouped.get(moduleId).push(item)
			})

			const result = []
			grouped.forEach(items => {
				const moduleId = items[0]?.moduleId ?? items[0]?.module_id ?? null
				const moduleStatus = statusMap.get(moduleId) || 'available'
				const hasOrder = items.some(
					item =>
						this.getHomeworkOrder(item) !== null &&
						this.getHomeworkOrder(item) !== undefined,
				)
				const sorted = hasOrder
					? items
							.slice()
							.sort(
								(a, b) =>
									(this.getHomeworkOrder(a) ?? 0) -
									(this.getHomeworkOrder(b) ?? 0),
							)
					: items.slice()

				const firstIncompleteIndex = sorted.findIndex(
					item =>
						!this.isHomeworkSubmitted(item) &&
						!this.isHomeworkCompleted(item) &&
						!this.isHomeworkLate(item),
				)

				sorted.forEach((item, index) => {
					if (moduleStatus === 'locked') {
						result.push({ ...item, status: 'locked' })
						return
					}
					if (
						this.isHomeworkCompleted(item) ||
						this.isHomeworkSubmitted(item) ||
						this.isHomeworkLate(item) ||
						firstIncompleteIndex === -1 ||
						index <= firstIncompleteIndex
					) {
						result.push({ ...item, status: 'available' })
						return
					}
					result.push({ ...item, status: 'locked' })
				})
			})

			return result
		},

		/**
		 * Последовательная загрузка всех данных с задержками
		 * для избежания 429 ошибок
		 */
		async loadAllDataSequentially() {
			try {
				// 1. Сначала загружаем курсы студента (самое важное)
				console.log('📚 Загрузка курсов студента...')
				await this.loadEnrolledCourses()

				// Пауза между запросами для избежания rate limiting
				await delay(500)

				// 2. Затем загружаем все доступные курсы (для рекомендаций)
				console.log('📚 Загрузка всех курсов...')
				await this.loadCourses()

				await delay(500)

				// 3. Загружаем конференции
				console.log('📅 Загрузка конференций...')
				await this.loadStudentConferences()

				await delay(500)

				// 4. Загружаем модули и домашки только если есть курсы
				if (this.enrolledCourseIds && this.enrolledCourseIds.length > 0) {
					console.log('📦 Загрузка модулей и домашек...')
					await this.loadModulesAndHomework(this.enrolledCourseIds)
				}

				this.updateCourseChoiceModalState()
				this.maybeStartOnboarding()
				console.log('✅ Все данные загружены')
			} catch (error) {
				console.error('❌ Ошибка загрузки данных:', error)
				this.updateCourseChoiceModalState()
				this.maybeStartOnboarding()
			}
		},

		/**
		 * Загрузка модулей и домашних заданий с контролем rate limiting
		 */
		async loadModulesAndHomework(courseIds) {
			if (!courseIds || courseIds.length === 0) {
				this.allModules = []
				this.allHomework = []
				return
			}

			const activeCourseIds = courseIds.filter(courseId => {
				const enrollment = this.enrolledCourses.find(
					c => String(c.courseId) === String(courseId)
				)
				return !this.isEnrollmentPaused(enrollment)
			})

			if (activeCourseIds.length === 0) {
				this.allModules = []
				this.allHomework = []
				return
			}

			this.loadingModules = true
			this.loadingHomework = true

			try {
				// ========================================
				// СОЗДАЕМ МАППИНГ courseId → courseName
				// ========================================
				const courseMap = {}
				const courseStatusMap = {}
				this.enrolledCourses.forEach(c => {
					if (this.isEnrollmentPaused(c)) return
					courseMap[c.courseId] = c.title || c.name || `Курс ${c.courseId}`
					courseStatusMap[c.courseId] =
						c.enrollment_status ??
						c.enrollmentStatus ??
						c.status ??
						c.state ??
						c.course_status ??
						c.courseStatus ??
						null
				})

				// ========================================
				// 1. Загружаем модули
				// ========================================
				console.log(
					`📦 Загрузка модулей для ${activeCourseIds.length} курсов...`
				)

				const modulesArrays = await batchRequests(
					activeCourseIds,
					async courseId => {
						try {
							const modules = await modulesService.getByCourseId(courseId)
							// Добавляем courseName к каждому модулю
							return (modules || []).map(m => ({
								...m,
								courseName: courseMap[courseId] || `Курс ${courseId}`,
								courseStatus: courseStatusMap[courseId] || null,
							}))
						} catch (err) {
							console.warn(`⚠️ Не удалось загрузить модули курса ${courseId}`)
							return []
						}
					},
					2,
					400
				)

				const allModulesRaw = modulesArrays.filter(arr => arr !== null).flat()

				const isHiddenModule = module => {
					if (!module) return false
					if (module.isHidden === true || module.hidden === true) return true
					if (this.normalizeBoolean(module.is_hidden) === true) return true
					if (this.normalizeBoolean(module.is_draft) === true) return true
					return false
				}

				const visibleModulesRaw = allModulesRaw.filter(
					module => !isHiddenModule(module)
				)

				// Сортируем: сначала по курсу, потом по order_number
				visibleModulesRaw.sort((a, b) => {
					// Сравниваем названия курсов
					const courseCompare = (a.courseName || '').localeCompare(
						b.courseName || ''
					)
					if (courseCompare !== 0) return courseCompare

					// Внутри курса сортируем по order_number
					const orderA = a.order_number ?? a.id ?? 0
					const orderB = b.order_number ?? b.id ?? 0
					return orderA - orderB
				})

				// Форматируем модули
				this.allModules = this.applyModuleProgressLocks(
					visibleModulesRaw.map(module => this.formatModule(module)),
				)
				this.loadingModules = false

				const startModuleCounts = () => {
					this.fetchModuleContentCounts(this.allModules).catch(err => {
						console.warn('Failed to load module content counts:', err)
					})
				}

				console.log(`✅ Загружено ${this.allModules.length} модулей`)

				// ========================================
				// 2. Загружаем домашки
				// ========================================
				const moduleIds = visibleModulesRaw.map(m => m.id).filter(Boolean)

				if (moduleIds.length === 0) {
					this.allHomework = []
					this.loadingHomework = false
					startModuleCounts()
					return
				}

				// Создаем маппинг moduleId → courseName
				const moduleToCourseName = {}
				const moduleToCourseStatus = {}
				visibleModulesRaw.forEach(m => {
					moduleToCourseName[m.id] = m.courseName
					moduleToCourseStatus[m.id] = m.courseStatus
				})

				const limitedModuleIds = moduleIds

				console.log(
					`📝 Загрузка домашек для ${limitedModuleIds.length} модулей...`
				)

				await delay(300)

				const homeworkArrays = await batchRequests(
					limitedModuleIds,
					async moduleId => {
						try {
							const homework = await homeworkService.getByModuleId(
								moduleId,
								false
							)
							// Добавляем courseName к каждому ДЗ
							return (homework || []).map(hw => ({
								...hw,
								courseName: moduleToCourseName[moduleId] || 'Неизвестный курс',
								courseStatus: moduleToCourseStatus[moduleId] || null,
							}))
						} catch (err) {
							console.warn(`⚠️ Не удалось загрузить ДЗ модуля ${moduleId}`)
							return []
						}
					},
					2,
					400
				)

				const allHomeworkRaw = homeworkArrays.filter(arr => arr !== null).flat()
				const hiddenHomeworkModuleIds = new Set(
					this.allModules
						.filter(module => module?.isCompleted || module?.isPaused)
						.map(module => String(module?.id))
						.filter(Boolean),
				)
				const visibleHomeworkRaw = allHomeworkRaw.filter(hw => {
					const moduleId = hw?.module_id ?? hw?.moduleId ?? null
					if (moduleId === null || moduleId === undefined) return true
					return !hiddenHomeworkModuleIds.has(String(moduleId))
				})

				// Сортируем ДЗ по курсам
				visibleHomeworkRaw.sort((a, b) => {
					return (a.courseName || '').localeCompare(b.courseName || '')
				})

				this.allHomework = this.applyHomeworkProgressLocks(
					visibleHomeworkRaw.map(hw => this.formatHomework(hw)),
				)
				startModuleCounts()

				console.log(`✅ Загружено ${this.allHomework.length} домашних заданий`)
			} catch (error) {
				console.error('❌ Ошибка загрузки модулей/домашек:', error)
			} finally {
				this.loadingModules = false
				this.loadingHomework = false
			}
		},

		async fetchModuleContentCounts(modules) {
			if (!Array.isArray(modules) || modules.length === 0) {
				return
			}
			if (this.moduleCountsInFlight) return
			if (this.moduleCountsBackoffUntil > Date.now()) return

			const modulesToFetch = modules.filter(module => {
				if (!module?.id) return false
				const counts = module.contentCounts || {}
				const values = Object.values(counts)
				const hasUnknown = values.some(
					value => value === null || value === undefined
				)
				if (!hasUnknown) return false
				const hasAny = values.some(value => Number(value) > 0)
				return !hasAny
			}).slice(0, 6)

			if (modulesToFetch.length === 0) {
				return
			}

			this.moduleCountsInFlight = true
			try {
				const results = []

				for (const module of modulesToFetch) {
					const moduleId = module.id
					try {
						const lessons = await lessonsService.getByModuleId(moduleId, false)
						await delay(120)
						const tests = await testsService.getByModuleId(moduleId, false)
						await delay(120)
						const homework = await homeworkService.getByModuleId(moduleId, false)
						await delay(120)
						const practice = await practicalService.getByModuleId(moduleId, false)

						const contentCounts = {
							lessons: Array.isArray(lessons) ? lessons.length : null,
							tests: Array.isArray(tests) ? tests.length : null,
							homework: Array.isArray(homework) ? homework.length : null,
							practice: Array.isArray(practice) ? practice.length : null,
						}

						if (Object.values(contentCounts).some(value => value === null)) {
							continue
						}

						results.push({ id: moduleId, contentCounts })
					} catch (error) {
						if (this.isRateLimitError(error)) {
							const retryAfterMs = this.getRetryAfterMs(error, 120000)
							this.moduleCountsBackoffUntil = Date.now() + retryAfterMs
							console.warn(
								`⏸️ Пропускаем загрузку счетчиков модулей из-за 429. Повтор через ${Math.ceil(
									retryAfterMs / 1000,
								)} сек.`,
							)
							break
						}
						console.warn(
							`⚠️ Не удалось загрузить счетчики контента для модуля ${moduleId}:`,
							error?.message || error,
						)
					}

					await delay(180)
				}

				const countMap = new Map(
					results
						.filter(Boolean)
						.map(result => [result.id, result.contentCounts])
				)

				if (!countMap.size) {
					return
				}

				this.allModules = this.allModules.map(module => {
					const contentCounts = countMap.get(module.id)
					if (!contentCounts) return module
					const isEmpty = Object.values(contentCounts).every(
						value => Number(value) === 0
					)
					return { ...module, contentCounts, isEmpty }
				})
			} finally {
				this.moduleCountsInFlight = false
			}
		},

		/**
		 * Форматирование модуля для отображения
		 */
		formatModule(module) {
			const rawStatus = String(module?.status || '').toLowerCase()
			const isHidden = module.is_draft === true || module.is_hidden === true
			const isPaused =
				this.normalizeBoolean(module?.is_paused) === true ||
				this.normalizeBoolean(module?.paused) === true ||
				this.isPausedStatus(rawStatus)
			const isExplicitlyLocked =
				this.normalizeBoolean(module?.is_locked) === true ||
				['locked', 'closed', 'inactive'].includes(rawStatus)
			const isCompleted = this.isModuleCompleted(module)
			let status = 'available'
			if (isHidden || isExplicitlyLocked) {
				status = 'locked'
			}
			if (isPaused) {
				status = 'locked'
			}
			if (isCompleted) {
				status = 'completed'
			}

			let date = ''
			const dateSource =
				module.published_at || module.created_at || module.updated_at
			if (dateSource) {
				date = formatDateTimeValue(dateSource)
			}

			const extractCount = value => {
				if (Array.isArray(value)) return value.length
				if (value === null || value === undefined) return null
				if (typeof value === 'number' && !Number.isNaN(value)) return value
				if (typeof value === 'string' && value.trim() !== '') {
					const parsed = Number(value)
					return Number.isNaN(parsed) ? null : parsed
				}
				return null
			}

			const elements = module?.elements || {}
			const contentCounts = {
				lessons: extractCount(
					elements.lessons ??
						module.lessons ??
						module.lessons_count ??
						module.lessonsCount ??
						module.lesson_count
				),
				tests: extractCount(
					elements.tests ??
						module.tests ??
						module.tests_count ??
						module.testsCount ??
						module.test_count
				),
				practice: extractCount(
					elements.practice ??
						module.practice ??
						module.practical ??
						module.practicalTasks ??
						module.practical_tasks ??
						module.practice_count ??
						module.practical_count ??
						module.practiceCount ??
						module.practicalCount
				),
				homework: extractCount(
					elements.homework ??
						module.homework ??
						module.homeworks ??
						module.homework_count ??
						module.homeworks_count ??
						module.homeworkCount
				),
			}
			const countValues = Object.values(contentCounts).filter(
				value => value !== null && value !== undefined
			)
			const isEmpty =
				countValues.length > 0 && countValues.every(value => value === 0)

			return {
				id: module.id,
				courseId: module.course_id,
				courseStatus: module.courseStatus ?? module.course_status ?? null,
				courseName: module.courseName || 'Неизвестный курс',
				name: module.title || module.name || '',
				description: module.description || '',
				date,
				status,
				isCompleted,
				isPaused,
				isHidden,
				isExplicitlyLocked,
				orderNumber: module.order_number,
				contentCounts,
				isEmpty,
			}
		},

		/**
		 * Форматирование домашнего задания для отображения
		 */
		formatHomework(hw) {
			let status = 'available'
			if (hw.is_draft === true || hw.is_hidden === true) {
				status = 'locked'
			}

			const dateValue =
				hw.deadline ||
				hw.due_date ||
				hw.dueDate ||
				hw.deadline_at ||
				hw.deadlineAt ||
				hw.due_at ||
				hw.dueAt ||
				''
			const timeValue =
				hw.due_time ||
				hw.dueTime ||
				hw.deadline_time ||
				hw.deadlineTime ||
				''
			const deadline = dateValue
				? formatDateTimeValue(dateValue, timeValue)
				: ''
			const order =
				hw.order ??
				hw.order_number ??
				hw.position ??
				hw.sort_order ??
				hw.sortOrder ??
				hw.index ??
				null
			const submissionStatus =
				hw.submission_status ??
				hw.submissionStatus ??
				hw.submission_state ??
				hw.submissionState ??
				null

			return {
				id: hw.id,
				moduleId: hw.module_id,
				courseStatus: hw.courseStatus ?? hw.course_status ?? null,
				courseName: hw.courseName || 'Неизвестный курс',
				name: hw.title || `ДЗ ${hw.id}`,
				deadline,
				status,
				order,
				dueDateValue: dateValue || null,
				dueTimeValue: timeValue || null,
				submissionStatus,
				is_submitted: hw.is_submitted,
				isSubmitted: hw.isSubmitted,
				submitted: hw.submitted,
				is_completed: hw.is_completed,
				isCompleted: hw.isCompleted,
				completed: hw.completed,
				completion_percent: hw.completion_percent ?? hw.completionPercent,
			}
		},

		// ========================================
		// Навигация по модулям
		// ========================================
		prevModulesPage() {
			if (this.modulesPage > 1) {
				this.modulesPage--
			}
		},

		nextModulesPage() {
			if (this.modulesPage < this.modulesTotalPages) {
				this.modulesPage++
			}
		},

		// ========================================
		// Навигация по домашкам
		// ========================================
		prevHomeworkPage() {
			if (this.homeworkPage > 1) {
				this.homeworkPage--
			}
		},

		nextHomeworkPage() {
			if (this.homeworkPage < this.homeworkTotalPages) {
				this.homeworkPage++
			}
		},

		// ========================================
		// Существующие методы
		// ========================================
		async loadStudentConferences() {
			this.conferencesError = ''
			try {
				await this.loadStudentConferencesBase()
			} catch (error) {
				console.error('Ошибка загрузки конференций:', error)
				this.conferencesError =
					'Не удалось загрузить конференции. Попробуйте позже.'
			}
		},

		handleSearch(query) {
			this.search(query)
		},

		updateCourseChoiceModalState() {
			if (this.courseChoiceModalDismissed) {
				this.showCourseSelectionModal = false
				return
			}
			const hasNoCourses =
				!this.loadingEnrolled &&
				(!Array.isArray(this.enrolledCourses) || this.enrolledCourses.length === 0)
			this.showCourseSelectionModal = hasNoCourses
		},

		maybeStartOnboarding() {
			if (this.showOnboardingTour) return
			if (this.onboardingSavedInSession) return
			if (this.hasSeenOnboarding !== false) return
			this.showOnboardingTour = true
		},

		async restartOnboardingTour() {
			this.showCourseSelectionModal = false
			if (this.showOnboardingTour) {
				this.showOnboardingTour = false
				await this.$nextTick()
			}
			this.showOnboardingTour = true
		},

		async handleOnboardingFinish() {
			this.showOnboardingTour = false
			if (this.onboardingSavedInSession) return
			this.onboardingSavedInSession = true
			await this.markOnboardingAsSeen()
		},

		handleCourseChoiceDismiss() {
			this.courseChoiceModalDismissed = true
			this.showCourseSelectionModal = false
		},

		async markOnboardingAsSeen() {
			try {
				const usersServiceModule = await import('@/services/users')
				const usersService = usersServiceModule.default || usersServiceModule
				await usersService.updateCurrentProfile({
					has_seen_onboarding: true,
				})
			} catch (error) {
				console.warn('Не удалось сохранить статус onboarding в БД:', error)
			}

			try {
				const appStore = useAppStore()
				const current = appStore.currentUser || {}
				const next = {
					...current,
					hasSeenOnboarding: true,
					has_seen_onboarding: true,
					isFirstLogin: false,
					is_first_login: false,
				}
				appStore.setUser(next)
				appStore.persistUser()
				localStorage.setItem('is_first_login', 'false')
			} catch (error) {
				console.warn('Не удалось обновить локальный флаг onboarding:', error)
			}
		},

		goToCatalogFromModal(query = '') {
			const normalizedQuery = String(query || '').trim()
			const routeOptions = normalizedQuery
				? { path: '/search-courses', query: { q: normalizedQuery } }
				: { path: '/search-courses' }
			this.$router.push(routeOptions)
		},

		goToCourse(courseId) {
			if (!courseId) return
			this.$router.push({
				name: 'CoursePreview',
				params: { id: courseId },
			})
		},

		goToEnrolledCourse(course) {
			if (!course?.courseId) return
			this.$router.push({
				name: 'StudentCoursePage',
				params: { id: course.courseId },
			})
		},

		onMoreCoursesClick() {
			this.$router.push('/my-courses')
		},

		onTogglePast(value) {
			this.togglePast(value)
		},

		async joinConference(conf) {
			try {
				await this.joinConferenceAction(conf, this.$router)
			} catch (error) {
				console.error('Ошибка:', error)
				const { useAppStore } = await import('@/stores/useAppStore')
				const appStore = useAppStore()
				appStore.showError(
					'Не удалось подключиться к конференции. Попробуйте ещё раз.'
				)
			}
		},

		async handleLogout() {
			try {
				const { authService } = await import('@/services/auth')
				const { useAppStore } = await import('@/stores/useAppStore')
				const appStore = useAppStore()

				await authService.logout()
				appStore.showSuccess('Вы успешно вышли из системы')
				this.$router.push('/auth')
			} catch (error) {
				console.error('Ошибка выхода:', error)
			}
		},

		onProfileClick() {
			alert('Профиль пользователя будет доступен скоро!')
		},

		scrollToTop() {
			window.scrollTo(0, 0)
		},
	},
}
</script>

<style scoped>
.paginated-section {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.pagination-controls {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	margin-top: 16px;
	padding: 8px 0;
}

.pagination-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background-color: #ffffff;
	color: #333;
	cursor: pointer;
	transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
	background-color: #f5f5f5;
	border-color: #ccc;
}

.pagination-btn:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.pagination-btn:focus {
	outline: none;
	box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.3);
}

.pagination-info {
	font-size: 14px;
	color: #666;
	font-weight: 500;
	min-width: 50px;
	text-align: center;
}

/* Адаптив для мобильных */
@media (max-width: 768px) {
	.pagination-controls {
		gap: 12px;
		margin-top: 12px;
	}

	.pagination-btn {
		width: 32px;
		height: 32px;
	}

	.pagination-info {
		font-size: 13px;
	}
}
/* ============================================
   ОСНОВНОЙ КОНТЕЙНЕР
   ============================================ */
.student-dashboard {
	background-color: #f9f9f980;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	/* min-width: 1920px; */
	overflow-x: hidden;
	width: 100%;
}

.dashboard-content {
	display: flex;
	flex-direction: column;
	flex: 1;
	position: relative;
	padding-bottom: 100px;
	--my-courses-offset: 0px;
}

/* ============================================
   ХЕДЕР И ЗАГОЛОВОК (остаются absolute)
   ============================================ */
.main-title {
	left: calc(50% - 566px);
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 143px;
	width: 1129px;
}

/* ============================================
   МОИ КУРСЫ (остаётся absolute)
   ============================================ */
.my-courses-position {
	position: absolute;
	top: 244px;
	left: 0;
	width: 100%;
}

/* ============================================
   БЛОКИ С КОНТЕНТОМ - ДИНАМИЧЕСКАЯ ВЕРСТКА
   ============================================ */
.content-blocks {
	display: flex;
	flex-direction: column;
	gap: clamp(16px, 2vw, 24px);
	margin-top: clamp(800px, 40vw, 556px); /* Отступ от "Мои курсы" */
	width: 100%;
	max-width: 1407px;
	margin-left: auto;
	margin-right: auto;
	padding: 0 20px;
}

/* Обёртка для конференций - занимает всю ширину */
.conferences-wrapper {
	width: 100%;
	/* margin-top: 20px; */
}

/* Строка: Модули + Календарь */
.modules-calendar-row {
	display: flex;
	gap: 24px;
	align-items: flex-start;
}

.modules-homework-column {
	display: flex;
	flex-direction: column;
	gap: 15px;
	flex: 0 0 819px; /* Фиксированная ширина как было */
}

.modules-wrapper {
	width: 100%;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	border-radius: 20px;
}

.calendar-wrapper {
	flex: 1;
	min-width: 400px;
}

.homework-wrapper {
	width: 100%;
}

.extra-wrapper {
	flex: 1;
	min-width: 400px;
}

/* ============================================
   РЕКОМЕНДУЕМЫЕ КУРСЫ
   ============================================ */
.recommended-courses-wrapper {
	margin-top: 60px;
	width: 100%;
	scroll-margin-top: 24px;
}

.recommended-filter-bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px;
	margin-bottom: 0;
}


.recommended-filter-select {
	border: 1px solid #d9d9d9;
	border-radius: 10px;
	padding: 8px 12px;
	font-size: 14px;
	background-color: #ffffff;
	color: #2f2f2f;
	min-width: 240px;
}

.recommended-filter-select:focus {
	outline: none;
	border-color: #4a6cf7;
	box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.2);
}

.student-onboarding-restart {
	position: fixed;
	left: 18px;
	bottom: 24px;
	z-index: 1200;
	display: inline-flex;
	align-items: center;
	gap: 8px;
	height: 52px;
	width: 52px;
	padding: 0 14px;
	border: 1px solid #0096ed;
	border-radius: 999px;
	background: #ffffff;
	box-shadow: 0 10px 22px rgba(0, 150, 237, 0.22);
	color: #0096ed;
	cursor: pointer;
	overflow: hidden;
	white-space: nowrap;
	transition: width 0.24s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.student-onboarding-restart:hover,
.student-onboarding-restart:focus-visible {
	width: 220px;
	border-color: #0096ed;
	background: #ffffff;
	color: #0096ed;
	box-shadow: 0 12px 28px rgba(0, 150, 237, 0.3);
}

.student-onboarding-restart:active {
	border-color: #0096ed;
	background: #ffffff;
	color: #0096ed;
	transform: scale(0.98);
}

.student-onboarding-restart:focus-visible {
	outline: none;
}

.student-onboarding-restart__icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.student-onboarding-restart__label {
	opacity: 0;
	transform: translateX(-6px);
	transition: opacity 0.2s ease, transform 0.2s ease;
	font-size: 14px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.student-onboarding-restart:hover .student-onboarding-restart__label,
.student-onboarding-restart:focus-visible .student-onboarding-restart__label {
	opacity: 1;
	transform: translateX(0);
}

@media (max-width: 768px) {
	.student-onboarding-restart {
		left: 12px;
		top: auto;
		bottom: 16px;
		transform: none;
	}

	.student-onboarding-restart:active {
		transform: scale(0.98);
	}
}






/* ===== АДАПТИВНОЕ МАСШТАБИРОВАНИЕ ПОД РАЗНЫЕ РАЗРЕШЕНИЯ И МАСШТАБЫ БРАУЗЕРА ===== */
/* Дизайн создан для 1920px, поэтому нужно масштабирование для меньших разрешений */

/* Экраны ≤1366px (реальные мониторы 1366×768) */
@media (max-width: 1366px) {
	body {
		zoom: 0.711; /* 1366 ÷ 1920 = 0.711 */
	}

	.content-blocks {
		margin-top: calc(var(--my-courses-offset) + 40px);
	}
}

/* Экраны 1367-1600px (включает FullHD с масштабом 125%: 1920÷1.25=1536px) */
@media (min-width: 1367px) and (max-width: 1600px) {
	body {
		zoom: 0.85; /* Компромисс между 0.711 и 1.0 для промежуточных разрешений */
	}

	.content-blocks {
		margin-top: calc(var(--my-courses-offset) + 40px);
	}
}

/* QHD 2560x1440 (15.6") — компенсация под 100% масштаб (как при 90%) */
/* При масштабе Windows 150% браузер видит ~1707px (2560/1.5) */
@media (min-width: 1601px) and (max-width: 1800px) {
	body {
		zoom: 0.9 !important;
	}

	.content-blocks {
		margin-top: calc(var(--my-courses-offset) + 40px);
	}
}

/* Экраны 1801-2300px - без дополнительного масштабирования */
@media (min-width: 1801px) and (max-width: 2300px) {
	body {
		zoom: 1.0 !important;
	}
}

/* QHD 2560x1440 с масштабом Windows 100% - увеличение до 150% */
/* При масштабе Windows 100% браузер видит полные 2560px */
@media (min-width: 2301px) and (max-width: 2880px) {
	body {
		zoom: 1.35 !important;
	}
}

</style>
